import { render, staticRenderFns } from "./orcamento.vue?vue&type=template&id=22c9b9be"
import script from "./orcamento.vue?vue&type=script&lang=js"
export * from "./orcamento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports